// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { _DYN_SDK_EXTENSION } from "../__DynamicConstants";
var Version = '2.8.8';
var Internal = /** @class */ (function () {
    /**
     * Constructs a new instance of the internal telemetry data class.
     */
    function Internal(config) {
        this.sdkVersion = (config[_DYN_SDK_EXTENSION /* @min:%2esdkExtension */] && config[_DYN_SDK_EXTENSION /* @min:%2esdkExtension */]() ? config[_DYN_SDK_EXTENSION /* @min:%2esdkExtension */]() + "_" : "") + "javascript:" + Version;
    }
    return Internal;
}());
export { Internal };
//# sourceMappingURL=Internal.js.map